import { localStorageUtil } from '../../utils/local-storage.util';

export type CompanySetupEnterpriseProgressProps = Record<string, boolean>;

export const companySetupEnterpriseProgressStore =
  localStorageUtil<CompanySetupEnterpriseProgressProps>('companySetupEnterpriseProgress');
